module.exports = __webpack_public_path__ + "img/blockAB32.e711edba.svg";